var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};

/*
* A function that will extract a set of combination of values (ids)
* listed inside brackets for a given dimension from an annotation
*
* @memberOf SDMXJS
* @api public
* @tag data
* @param {Object}
* @return {Object}
*
*@example
* const annotation = { title: 'DIM1=(ID1+ID2),DIM2=(ID1+ID2+ID3),DIM3=ID1+ID2' }
*
* SDMXJS.getNotDisplayedCombinations(params);
* //=> {
* //     DIM1: ['ID1', 'ID2'],
* //     DIM2: ['ID1', 'ID2', 'ID3'],
* //   };
*/

import * as R from 'ramda';
export var getNotDisplayedCombinations = function getNotDisplayedCombinations(annotation) {
  return R.pipe(R.prop('title'), R.split(','), R.reduce(function (acc, dimension) {
    var _extends2;
    var _dimension$split = dimension.split('='),
      dim = _dimension$split[0],
      value = _dimension$split[1];
    var values = R.ifElse(R.test(/\((.*?)\)/g), R.pipe(R.match(/\((.*?)\)/g), R.head, R.replace(/[()]/g, ''), R.split('+')), R.always(''))(value);
    return R.head(values) ? _extends({}, acc, (_extends2 = {}, _extends2[dim] = values, _extends2)) : acc;
  }, {}))(annotation);
};